<template>
  <app-layout>
    <profile-data-table :title="$t('Asesores')" profile="consultant"></profile-data-table>
  </app-layout>
</template>
<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import ProfileDataTable from '../components/profiles/ProfileDataTable.vue';
export default {
  components: {
    AppLayout,
    ProfileDataTable,
  },
};
</script>
